import { render, staticRenderFns } from "./Shortcut.vue?vue&type=template&id=6f097c4f"
import script from "./Shortcut.vue?vue&type=script&lang=js"
export * from "./Shortcut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports